/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 UserProfileSettings = {
    favoriteBadges: {
        choose: function() {
            var badge = $(this);

            if (badge.hasClass('active')) {
                badge.removeClass('active');
                UserProfileSettings.favoriteBadges.save();
            } else {
                if($(".user-profile-box-badge.active").length < 3) {
                    badge.addClass('active');
                    UserProfileSettings.favoriteBadges.save();
                }
            }
        },
        save: function() {
            var ids = [];

            $(".user-profile-box-badge.active").each(function() {
                var id = $(this).data('id');
                ids.push(id);
            });

            $.ajax({
                url: '/a/user/profileSettings/saveBadges',
                type: 'POST',
                dataType: 'json',
                data: {'ids': ids},
            }).done(function(data) {
                if (data.status == 'error') {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Erro ao salvar emblemas",
                        content: message,
                        type: 'error'
                    });
                }
            });
        }
    },
    orderBadges: {
        save: function() {
            var sortBox = $("#user-badges-sort");

            var ids = [];

            $(".box-badge-order").each(function() {
                var badgeId = $(this).data('id');

                ids.push(badgeId);
            });

            $.ajax({
                url: '/a/user/profileSettings/saveBadgesOrder',
                type: 'POST',
                dataType: 'json',
                data: {'ids': ids},
            }).done(function(data) {
            });
        }
    },
    changeCoverImage: function() {
        $(".user-profile-cover-select .box-cover-image").removeClass('active');

        var id = $(this).data('id');
        $("input[name='forum_cover']").val(id);

        $(this).addClass('active');
    },
    init: function() {
        $("#user-profile-avatar-input").on('change', function() {
            var input = this;

            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    $("#user-profile-avatar-preview").css('background-image', 'url('+e.target.result+')');
                };

                reader.readAsDataURL(input.files[0]);
            }
        });

        /*
        $("#user-profile-forum-cover-input").on('change', function() {
            var input = this;

            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    $("#user-profile-forum-cover-preview").css('background-image', 'url('+e.target.result+')');
                };

                reader.readAsDataURL(input.files[0]);
            }
        });
        */

        $(".user-profile-cover-select .box-cover-image").on('click', UserProfileSettings.changeCoverImage);

        //$(".user-profile-box-badge").on('click', UserProfileSettings.favoriteBadges.choose);

        $("#user-badges-sort").sortable();
        $("#user-badges-sort").on("sortupdate", UserProfileSettings.orderBadges.save);
        $("#user-badges-sort").attr('unselectable','on').css({'-moz-user-select':'-moz-none','-moz-user-select':'none','-o-user-select':'none','-khtml-user-select':'none','-webkit-user-select':'none','-ms-user-select':'none','user-select':'none'}).bind('selectstart', function(){ return false; });
    }
};
